import React from 'react';

const Donation = () => {
  return (
    <>
    <div className="overflow-hidden space" id="about-sec">
<div
  className="shape-mockup about-bg-shape2-1 jump-reverse"
  data-top="10%"
  data-right="5%"
>
  <img src="assets/img/shape/heart-shape1.png" alt="shape" />
</div>
<div className="container">
  <div className="row gx-60 gy-60 align-items-center">
    <div className="col-xl-6 col-lg-10">
      <div className="img-box2">
        <div className="img1">
          <img src="assets/img/normal/about_2_1.png" alt="About" />
        </div>
        <div className="img2 jump">
          <img src="assets/img/normal/about_2_2.png" alt="About" />
        </div>
        <div
          className="img3 moving"
          data-mask-src="assets/img/normal/about_2_3-mask.png"
        >
          <img
            data-mask-src="assets/img/normal/about_2_3-mask.png"
            src="assets/img/normal/about_2_3.png"
            alt="About"
          />
        </div>
        <div className="about-shape2-1 jump">
          <div className="color-masking">
            <div
              className="masking-src"
              data-mask-src="assets/img/shape/about_shape2_1.png"
            />
            <img src="assets/img/shape/about_shape2_1.png" alt="img" />
          </div>
        </div>
        <div className="about-shape2-2 jump-reverse">
          <div className="color-masking2">
            <div
              className="masking-src"
              data-mask-src="assets/img/shape/about_shape2_2.png"
            />
            <img src="assets/img/shape/about_shape2_2.png" alt="img" />
          </div>
        </div>
      </div>
    </div>
    <div className="col-xl-6">
      <div className="about-wrap2">
        <div className="title-area mb-35">
          {/* <span className="sub-title after-none before-none">
            Welcome to Donet Charity
          </span> */}
          <h2 className="sec-title">
          Gram seva Trust
          </h2>
          <p className="mt-30">
          Gram seva turst Organization is work from 20+ years which work on 
          social development of rural and tribes and various sector like Agriculture ,
          livelihood environmental awarness,education,nursery plantation etc.
          </p>
        </div>
        <div className="about-feature-grid">
        
          <div className="media-body">
            <h4 className="box-title">Fundraising</h4>
            <p className="box-text">
              Discover the inspiring stories of individuals and communities
              transformed by our programs.
            </p>
          </div>
        </div>
        <div className="about-feature-grid">
          {/* <div className="box-icon">
            <img src="assets/img/icon/about-icon2-2.svg" alt="icon" />
          </div> */}
          <div className="media-body">
            <h4 className="box-title">Donation Making</h4>
            <p className="box-text">
              Our success stories highlight the real-life impact of your
              donations and the resilience of those we help.
            </p>
          </div>
        </div>
        <div className="btn-wrap mt-40">
          <a href="/about" className="th-btn">
            About More
            <i className="fas fa-arrow-up-right ms-2" />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
 
    </>
  );
};

export default Donation;
